module.exports = __webpack_public_path__ + "img/pdf.3a775766.png";